import styled from 'styled-components';
import { Button as ShowroomButton } from '@carvana/showroom-forms';

export const Button = styled(ShowroomButton)`
  width: 252px;
  text-transform: uppercase;
`;

export const DefaultModalWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 2rem;

  a {
  text-decoration: none;
  }
`;

export const Heading = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  font-size: 28px;
  
`;

export const Content = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  margin: 24px 0;
`;
